<template lang="pug">
span#admin-navbar
  template(v-for="(navModule, key) in magicNav")
    b-navbar-item(
      v-if="key == 'Home'"
      :to="magicNav['Home'].uri"
      tag="router-link"
      exact
      :key="key"
      :id="magicNav['Home'].name.replace(' ', '')") {{ $t(`lang.navbar.${key}`)}}
    b-navbar-item(
      v-else-if="navModule && navModule.name"
      :to="navModule.uri"
      tag="router-link"
      exact
      :key="key"
      :id="navModule.name.replace(' ', '')") {{ $t(`lang.navbar.${navModule.name}`)}}
    b-navbar-dropdown(v-else :label="$t(`lang.navbar.${key}`)" boxed)
      b-navbar-item(
        v-for="(module, key) in navModule"
        :to="module.uri"
        tag="router-link"
        :key="key"
        :id="module.name.replace(' ', '')") {{$t(`lang.navbar.${module.name}`)}}
</template>

<script>
  export default {
    props:['magicNav'],
    data() {
      return {
        operatorRoutes: ['Availability', 'Bookings', 'Rates', 'Rate Plans'],
        hotelRoutes: ['Hotels', 'Inventory', 'Room Types', 'Child Policies'],
        adminRoutes: ['Integration', 'Logs', 'Logstock', 'E-mails', 'Users']
      }
    }
  }
</script>

<style lang="scss">
  #admin-navbar {
    display: flex;
    .navbar-link:not(.is-arrowless)::after{
      border-color: #0f766e;
    }
    a.navbar-item:focus-within,
    .navbar-link:focus,
    .navbar-link:focus-within,
    .navbar-link.is-active{
      color: #0f766e;
    }
    a.navbar-item:hover,
    a.navbar-item.is-active
    .navbar-link:hover,
    .navbar-link.is-active:hover{
      color:white;
      background-color: #0f766e;
    }
    > .navbar-item {
      height:52px;
    }
    @media (max-width:868px){
      flex-direction: column;
    }
  }
  @media (max-width:868px){
    .navbar .navbar-dropdown.is-boxed {
      background-color: #fff !important;
      z-index: 9999;
      position:relative;
      border: 1px solid;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DttAdminNavbarComponent.vue